import { MessageType } from 'models/Message';
import { ReactionType } from 'models/Reactions';
import utils, {
  isQuestionMarkReaction,
  isThumbsDownReaction,
  isThumbsUpReaction,
} from 'utils';

export const focusElement = (selector: string) => {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    setTimeout(() => (element as HTMLElement).focus(), 1000);
  }
};

export const setDatesToMessages = (messages: Array<MessageType>) => {
  return messages.map((msg, index, array) => {
    let showDate: string;

    const currentDate = utils.toDateFormat(msg?.createdAt);
    const nextDate = utils.toDateFormat(
      index < array.length - 1 && array[index + 1]?.createdAt,
    );

    if (
      index === array.length - 1 ||
      (index === 0 && currentDate !== nextDate) ||
      currentDate !== nextDate
    )
      showDate = currentDate;
    else showDate = null;

    return {
      ...msg,
      showDate,
    } as MessageType;
  });
};

export const getReactionNumbers = (reaction: ReactionType) => {
  if (!reaction) return {};

  return {
    thumbsUp: isThumbsUpReaction(reaction) ? 1 : 0,
    thumbsDown: isThumbsDownReaction(reaction) ? 1 : 0,
    questionMark: isQuestionMarkReaction(reaction) ? 1 : 0,
  };
};
